import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Header, Footer, PageTransition } from "@/components/Layout";
import ChooserPage from "@/pages/ChooserPage";
import HomePage from "@/pages/HomePage";
import ApproachPage from "@/pages/ApproachPage";
import DesignStylesPage from "@/pages/DesignStylesPage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import InvestmentPage from "@/pages/InvestmentPage";
import ContactPage from "@/pages/ContactPage";
import ModsPage from "@/pages/ModsPage";

const AppLayout = () => {
  const location = useLocation();
  const path = location.pathname;

  // Bare layout for the chooser landing — no header/footer.
  if (path === "/") {
    return (
      <PageTransition>
        <ChooserPage />
      </PageTransition>
    );
  }

  // Questionnaire is its own immersive flow.
  if (path === "/catapult/journey") {
    return (
      <PageTransition>
        <QuestionnairePage />
      </PageTransition>
    );
  }

  return (
    <>
      <Header />
      <PageTransition>
        <Routes>
          {/* Catapult */}
          <Route path="/catapult" element={<HomePage />} />
          <Route path="/catapult/approach" element={<ApproachPage />} />
          <Route path="/catapult/styles" element={<DesignStylesPage />} />
          <Route path="/catapult/investment" element={<InvestmentPage />} />
          <Route path="/catapult/contact" element={<ContactPage />} />

          {/* Mods */}
          <Route path="/mods" element={<ModsPage />} />

          {/* Legacy → Catapult redirects (anything bookmarked from before) */}
          <Route path="/approach" element={<Navigate to="/catapult/approach" replace />} />
          <Route path="/styles" element={<Navigate to="/catapult/styles" replace />} />
          <Route path="/investment" element={<Navigate to="/catapult/investment" replace />} />
          <Route path="/contact" element={<Navigate to="/catapult/contact" replace />} />
          <Route path="/journey" element={<Navigate to="/catapult/journey" replace />} />

          {/* Catch-all → home chooser */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </PageTransition>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/*" element={<AppLayout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
